import { useEffect, useState, useContext } from "react";
import { Button } from "@mui/material";
import InputText from "../../../shared/components/inputs/InputText/InputText";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "../categoriasFinanceiro/CategoriasFinanceiro.scss";
import { AuthContext } from "../../../shared/context/auth-context";
import { Popconfirm } from "antd";
import ErrorIcon from "@mui/icons-material/Error";
import toast from "react-hot-toast";
import { useLoading } from "../../../shared/context/LoadingContext";
import { TextField } from "@mui/material";

import BusinessIcon from "@mui/icons-material/Business";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotaPartilhaUnidades from "../components/NotaPartilhaUnidades";

function EmpresasParceiras({ sendRequest, clinicaId }) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [empresasParceiras, setEmpresasParceiras] = useState([]);
  const [mensagemDeErro, setMensagemDeErro] = useState("");
  const auth = useContext(AuthContext);

  // Campos do formulário
  const [nome, setNome] = useState("");
  const [percentagemDesconto, setPercentagemDesconto] = useState("");
  const [contacto, setContacto] = useState("");
  const [email, setEmail] = useState("");
  const [nif, setNif] = useState("");
  const [responsavel, setResponsavel] = useState("");
  const [endereco, setEndereco] = useState("");
  const [observacoes, setObservacoes] = useState("");
  const [dataFimContrato, setDataFimContrato] = useState("");

  useEffect(() => {
    const fetchEmpresasParceiras = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/empresasparceiras/clinica/${clinicaId}/todas`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setEmpresasParceiras(responseData.empresasParceiras);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchEmpresasParceiras();
  }, [auth.token, clinicaId, sendRequest]);

  const resetarValores = () => {
    setNome("");
    setPercentagemDesconto("");
    setContacto("");
    setEmail("");
    setNif("");
    setResponsavel("");
    setEndereco("");
    setObservacoes("");
    setDataFimContrato("");
  };

  const handleModalClose = () => {
    setMensagemDeErro("");
    setIdEmpresa(null);
    setOpenModal(false);
    resetarValores();
  };

  const guardarEmpresa = async () => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nome);
      formData.append("percentagemDesconto", percentagemDesconto);
      formData.append("clinica", clinicaId);
      formData.append("contacto", contacto);
      formData.append("email", email);
      formData.append("nif", nif);
      formData.append("responsavel", responsavel);
      formData.append("endereco", endereco);
      formData.append("observacoes", observacoes);
      if (dataFimContrato) {
        formData.append("dataFimContrato", dataFimContrato);
      }
      formData.append("criadoPor", auth.userId);

      const empresaCriada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/empresasparceiras/`,
        "POST",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      setEmpresasParceiras((current) => [
        ...current,
        empresaCriada.empresaParceira,
      ]);

      resetarValores();
      setOpenModal(false);
      setIdEmpresa(null);

      toast.success("Empresa parceira criada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const editarEmpresa = async (id) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("nome", nome);
      formData.append("percentagemDesconto", percentagemDesconto);
      formData.append("contacto", contacto);
      formData.append("email", email);
      formData.append("nif", nif);
      formData.append("responsavel", responsavel);
      formData.append("endereco", endereco);
      formData.append("observacoes", observacoes);
      if (dataFimContrato) {
        formData.append("dataFimContrato", dataFimContrato);
      }
      formData.append("atualizadoPor", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/empresasparceiras/${id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      const empresasCopy = [...empresasParceiras];
      const empresasModificadas = empresasCopy.map((emp) => {
        if (emp.id === id || emp._id === id) {
          return {
            id: id,
            _id: id,
            nome: nome,
            percentagemDesconto: Number(percentagemDesconto),
            contacto: contacto,
            email: email,
            nif: nif,
            responsavel: responsavel,
            endereco: endereco,
            observacoes: observacoes,
            dataFimContrato: dataFimContrato,
          };
        } else {
          return emp;
        }
      });

      setEmpresasParceiras([...empresasModificadas]);

      resetarValores();
      setIdEmpresa(null);
      setOpenModal(false);

      toast.success("Empresa parceira modificada com sucesso!");
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
    setIsSubmitting(false);
  };

  const preEditarEmpresa = async (id) => {
    setIdEmpresa(id);
    const empresaFiltrada = empresasParceiras.filter(
      (emp) => emp.id === id || emp._id === id
    )[0];

    setNome(empresaFiltrada.nome || "");
    setPercentagemDesconto(
      empresaFiltrada.percentagemDesconto?.toString() || ""
    );
    setContacto(empresaFiltrada.contacto || "");
    setEmail(empresaFiltrada.email || "");
    setNif(empresaFiltrada.nif || "");
    setResponsavel(empresaFiltrada.responsavel || "");
    setEndereco(empresaFiltrada.endereco || "");
    setObservacoes(empresaFiltrada.observacoes || "");
    setDataFimContrato(
      empresaFiltrada.dataFimContrato
        ? empresaFiltrada.dataFimContrato.substring(0, 10)
        : ""
    );
    setOpenModal(true);
  };

  const toggleAtivoEmpresa = async (id, ativoAtual) => {
    startLoading();
    try {
      const formDataToggle = new FormData();
      formDataToggle.append("utilizador", auth.userId);

      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/empresasparceiras/toggleativo/${id}`,
        "PATCH",
        formDataToggle,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      // Atualizar estado local
      setEmpresasParceiras((current) =>
        current.map((emp) => {
          if (emp.id === id || emp._id === id) {
            return { ...emp, ativo: !ativoAtual };
          }
          return emp;
        })
      );

      toast.success(
        ativoAtual
          ? "Empresa parceira desativada com sucesso!"
          : "Empresa parceira reativada com sucesso!"
      );
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const beforeSubmit = (idEmpresa) => {
    let haErro = false;

    // Verificar duplicidade
    let duplicidade = false;
    if (idEmpresa) {
      duplicidade = empresasParceiras.filter(
        (emp) =>
          emp._id !== idEmpresa &&
          emp.id !== idEmpresa &&
          emp.nome.toLowerCase() === nome.trim().toLowerCase()
      );
    } else {
      duplicidade = empresasParceiras.filter(
        (emp) => emp.nome.toLowerCase() === nome.trim().toLowerCase()
      );
    }

    if (!nome || nome.trim() === "") {
      setMensagemDeErro("O nome da empresa é obrigatório.");
      haErro = true;
    } else if (!percentagemDesconto || percentagemDesconto === "") {
      setMensagemDeErro("A percentagem de desconto é obrigatória.");
      haErro = true;
    } else if (
      Number(percentagemDesconto) < 0 ||
      Number(percentagemDesconto) > 100
    ) {
      setMensagemDeErro("A percentagem de desconto deve estar entre 0 e 100.");
      haErro = true;
    } else if (duplicidade?.length > 0) {
      setMensagemDeErro("Já existe uma empresa parceira com esse nome.");
      haErro = true;
    } else {
      setMensagemDeErro("");
    }

    if (!isSubmitting && !haErro) {
      setIsSubmitting(true);
      if (idEmpresa) {
        editarEmpresa(idEmpresa);
      } else {
        guardarEmpresa();
      }
    }
  };

  // Verificar se a parceria está dentro do período válido
  const isParceriaValida = (empresa) => {
    const hoje = new Date();
    if (empresa.dataFimContrato && new Date(empresa.dataFimContrato) < hoje) {
      return false;
    }
    return true;
  };

  const formatarData = (data) => {
    if (!data) return "-";
    return new Date(data).toLocaleDateString("pt-PT");
  };

  return (
    <>
      <div className="categoriasGeral__container">
        {(auth.role === "Médico/Administrador" || auth.role === "Gerente") && (
          <div
            className="categoriasGeral__container__btn-adicionar"
            style={{ width: "240px" }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={(e) => setOpenModal(true)}
            >
              Nova Empresa Parceira
            </Button>
          </div>
        )}

        <div
          style={{
            backgroundColor: "#e3f2fd",
            border: "1px solid #90caf9",
            borderRadius: "8px",
            padding: "16px 20px",
            marginBottom: "20px",
            display: "flex",
            gap: "15px",
            alignItems: "flex-start",
            gridColumn: "1/-1",
          }}
        >
          <InfoOutlinedIcon style={{ color: "#1976d2", marginTop: "2px" }} />
          <div
            style={{ fontSize: "14px", color: "#1565c0", lineHeight: "1.6" }}
          >
            <strong
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "15px",
              }}
            >
              Como funcionam as Empresas Parceiras?
            </strong>
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              <li>
                Colaboradores de empresas parceiras recebem{" "}
                <strong>desconto automático</strong> nos orçamentos.
              </li>
              <li>
                Associe a empresa ao cliente no cadastro para ativar o desconto.
              </li>
              <li>
                Se definir uma <strong>data de fim</strong>, o sistema desativa
                a parceria automaticamente quando expirar.
              </li>
              <li>
                Administradores e gerentes recebem{" "}
                <strong>alertas 7 dias antes</strong> do contrato expirar.
              </li>
              <NotaPartilhaUnidades />
            </ul>
          </div>
        </div>

        {empresasParceiras &&
          empresasParceiras.map((empresa, index) => {
            const valida = isParceriaValida(empresa);
            const isAtivo = empresa.ativo !== false;

            return (
              <div
                className="categoriasFinanceiro__container__categoria"
                key={index}
                style={{
                  opacity: isAtivo ? 1 : 0.5,
                  borderLeft: !isAtivo
                    ? "4px solid #9e9e9e"
                    : valida
                    ? "4px solid #4caf50"
                    : "4px solid #ff9800",
                  backgroundColor: !isAtivo ? "#f5f5f5" : "transparent",
                }}
              >
                <div className="categoriasFinanceiro__container__categoria--1">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <BusinessIcon
                      style={{ color: isAtivo ? "#175c93" : "#9e9e9e" }}
                    />
                    <div>
                      <div
                        style={{
                          fontWeight: "600",
                          color: isAtivo ? "inherit" : "#9e9e9e",
                        }}
                      >
                        {empresa.nome}
                        {!isAtivo && (
                          <span
                            style={{
                              marginLeft: "10px",
                              fontSize: "12px",
                              backgroundColor: "#9e9e9e",
                              color: "white",
                              padding: "2px 8px",
                              borderRadius: "4px",
                            }}
                          >
                            DESATIVADA
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: "13px", color: "#666" }}>
                        Desconto: {empresa.percentagemDesconto}%
                        {empresa.dataFimContrato && (
                          <span style={{ marginLeft: "15px" }}>
                            Válido até: {formatarData(empresa.dataFimContrato)}
                          </span>
                        )}
                        {isAtivo && !valida && (
                          <span
                            style={{
                              marginLeft: "15px",
                              color: "#ff9800",
                              fontWeight: "500",
                            }}
                          >
                            (Parceria expirada)
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="categoriasFinanceiro__container__categoria--2">
                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Gerente") && (
                    <Popconfirm
                      title={
                        isAtivo
                          ? "Desativar Empresa Parceira"
                          : "Reativar Empresa Parceira"
                      }
                      description={
                        isAtivo
                          ? "Confirma desativação da empresa parceira?"
                          : "Confirma reativação da empresa parceira?"
                      }
                      icon={
                        <ErrorIcon
                          style={{ color: isAtivo ? "red" : "green" }}
                        />
                      }
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={toggleAtivoEmpresa.bind(
                        null,
                        empresa.id || empresa._id,
                        isAtivo
                      )}
                      className="popConfirm--biggerPadding"
                    >
                      <span style={{ color: isAtivo ? "inherit" : "#4caf50" }}>
                        {isAtivo ? "Desativar" : "Reativar"}
                      </span>
                    </Popconfirm>
                  )}
                  {(auth.role === "Médico/Administrador" ||
                    auth.role === "Gerente") && (
                    <span
                      onClick={preEditarEmpresa.bind(
                        null,
                        empresa.id || empresa._id
                      )}
                    >
                      Editar
                    </span>
                  )}
                </div>
              </div>
            );
          })}

        {empresasParceiras.length === 0 && (
          <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
            Nenhuma empresa parceira cadastrada.
          </div>
        )}

        <Modal
          open={openModal}
          onClose={handleModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            className="fluxo-atendimento__modal__box adicionar-categoria__modal"
            id="modal__adicionar-categoria"
            style={{ maxWidth: "600px" }}
          >
            <h1 className="fluxo-atendimento__modal__titulo">
              Empresa Parceira
            </h1>

            <div
              className="adicionar-categoria__modal__container"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <InputText
                className="adicionar-categoria__modal__container--span2"
                label="Nome da Empresa *"
                initialValue={nome}
                handleChange={(valor) => setNome(valor)}
              />

              <TextField
                label="Percentagem de Desconto *"
                type="number"
                value={percentagemDesconto}
                onChange={(e) => setPercentagemDesconto(e.target.value)}
                inputProps={{ min: 0, max: 100, step: 0.5 }}
                fullWidth
                helperText="Valor entre 0 e 100"
              />

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "15px",
                }}
              >
                <InputText
                  label="Contacto"
                  initialValue={contacto}
                  handleChange={(valor) => setContacto(valor)}
                />
                <InputText
                  label="Email"
                  initialValue={email}
                  handleChange={(valor) => setEmail(valor)}
                />
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "15px",
                }}
              >
                <InputText
                  label="NIF"
                  initialValue={nif}
                  handleChange={(valor) => setNif(valor)}
                />
                <InputText
                  label="Pessoa Responsável"
                  initialValue={responsavel}
                  handleChange={(valor) => setResponsavel(valor)}
                />
              </div>

              <InputText
                label="Endereço"
                initialValue={endereco}
                handleChange={(valor) => setEndereco(valor)}
              />
              <TextField
                label="Data Fim Contrato"
                type="date"
                value={dataFimContrato}
                onChange={(e) => setDataFimContrato(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />

              <TextField
                label="Observações"
                multiline
                rows={3}
                value={observacoes}
                onChange={(e) => setObservacoes(e.target.value)}
                fullWidth
              />
            </div>

            {mensagemDeErro && (
              <div className="erroContainer__categoria-caixa">
                {mensagemDeErro}
              </div>
            )}

            <div className="fluxo-atendimento__modal__bottom_btns">
              <span
                className="cancel-btn"
                onClick={handleModalClose}
                style={{ display: "block" }}
              >
                Fechar
              </span>

              <span
                disabled={isSubmitting}
                className="blue-button"
                onClick={
                  idEmpresa
                    ? beforeSubmit.bind(null, idEmpresa)
                    : beforeSubmit.bind(null, null)
                }
              >
                {isSubmitting ? "Guardando..." : "Guardar"}
              </span>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default EmpresasParceiras;
